module.exports = __webpack_public_path__ + "img/icon_mouse_left.057a820c.png";